import { CountUp } from "countup.js";

export function counter() {
    const _document = document;
    const numbersWrap = _document.querySelector(".impact-of-depression .numbers");
    const numbers= numbersWrap.querySelectorAll(".number strong");
    
    [...numbers].forEach((num) => {
        let options = {
            separator: " ",
            duration: 7
        };
        let numData = num.textContent.replace(/\s/g, "").replace(/\,/g, ".");
        
        if(numData.indexOf(".") > -1) {
            options = { 
                decimalPlaces: 3,
                decimal: ",",
                duration: 7
            };
        }
        numData = +numData;
        var countUp = new CountUp(num, numData, options);
        countUp.start();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/counter.js